import { WEBSITE_PACKAGES, SUPPORT_PLANS } from "../data/pricing";
import { SERVICE_OPTIONS } from "../data/content";
import { ROUTE_META, normalizePath } from "../data/routes.mjs";
const GA_MEASUREMENT_ID =
  process.env.REACT_APP_GA_MEASUREMENT_ID || "G-0KD894PMYF";
let initialised = false;
const canTrack = () =>
  typeof window !== "undefined" &&
  typeof document !== "undefined" &&
  ["thrivehausdigital.com.au", "www.thrivehausdigital.com.au"].includes(
    window.location.hostname,
  ) &&
  !window.navigator.globalPrivacyControl &&
  GA_MEASUREMENT_ID;
export const initAnalytics = () => {
  if (!canTrack()) return false;
  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function gtag() {
      window.dataLayer.push(arguments);
    };
  if (!initialised) {
    const path = normalizePath(window.location.pathname);
    window.gtag("js", new Date());
    window.gtag("config", GA_MEASUREMENT_ID, {
      send_page_view: false,
      page_location: `${window.location.origin}${ROUTE_META[path] ? path : "/404"}`,
      allow_google_signals: false,
      allow_ad_personalization_signals: false,
    });
    const load = () => {
      if (document.querySelector('script[data-thrivehaus-ga="true"]')) return;
      const script = document.createElement("script");
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GA_MEASUREMENT_ID)}`;
      script.dataset.thrivehausGa = "true";
      document.head.appendChild(script);
    };
    if (window.requestIdleCallback)
      window.requestIdleCallback(load, { timeout: 3000 });
    else window.setTimeout(load, 1000);
    initialised = true;
  }
  return true;
};
export const trackPageView = ({ path }) => {
  if (!initAnalytics()) return;
  const canonical = normalizePath(path);
  const safePath = ROUTE_META[canonical] ? canonical : "/404";
  window.gtag("event", "page_view", {
    page_title: document.title,
    page_location: `${window.location.origin}${safePath}`,
    page_path: safePath,
  });
};
const SAFE_VALUES = {
  lead_type: ["enquiry", "call", "call_request"],
  service: [
    ...SERVICE_OPTIONS,
    "websites",
    "seo",
    "ai-search",
    "automation",
    "support",
    "Call Request",
    "unspecified",
  ],
  plan: [
    ...WEBSITE_PACKAGES.map((item) => item.name),
    ...SUPPORT_PLANS.map((item) => item.name),
    "Not sure yet",
    "N/A",
  ],
  source: [...Object.keys(ROUTE_META), "other"],
  category: ["websites", "care", "specialist"],
  package: [...WEBSITE_PACKAGES.map((item) => item.slug), "unspecified"],
  support: [...SUPPORT_PLANS.map((item) => item.slug), "unspecified"],
  preview_requested: ["yes", "no"],
};
export const trackEvent = (name, parameters = {}) => {
  if (!name || !initAnalytics()) return;
  const safe = Object.fromEntries(
    Object.entries(parameters).filter(([key, value]) =>
      SAFE_VALUES[key]?.includes(value),
    ),
  );
  const path = normalizePath(window.location.pathname);
  window.gtag("event", name, {
    ...safe,
    page_location: `${window.location.origin}${ROUTE_META[path] ? path : "/404"}`,
  });
};
export { GA_MEASUREMENT_ID };
